import { render, staticRenderFns } from "./QueryAnswerTypeForm.vue?vue&type=template&id=3895d710"
import script from "./QueryAnswerTypeForm.vue?vue&type=script&lang=js"
export * from "./QueryAnswerTypeForm.vue?vue&type=script&lang=js"
import style0 from "./QueryAnswerTypeForm.vue?vue&type=style&index=0&id=3895d710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports